import React, { useEffect } from 'react'
import './Meditation_blog_details.css'
import Breadcrumb_Comp from '../common/common_components/breadcrumb_comp/Breadcrumb_Comp'
import Common_Back_Header from '../common/common_components/common_back_header/Common_Back_Header'
import { useParams } from 'react-router-dom'
import { AllBlog, SingleBlog } from '../../features/admin/common/Slice'
import { useDispatch, useSelector } from 'react-redux'
import { IDS } from '../../utils/IDS'
import parse from "html-react-parser"

const Meditation_blog_details = () => {

  const id = useParams();
  const dispatch = useDispatch();

  const blog = useSelector((state) => state.common.single_blog);

  useEffect(() => {
    if (id) {
      dispatch(SingleBlog(id));
    }
  }, [dispatch]);


  return (
    <>
      <section className='meditation_blog_details_sec'>
        <div className='container'>
          <Common_Back_Header backNavigation={-1} />

          <div className='banner_div'>
            <img className='medbanner' src={IDS.IMG_URL + blog?.Blog?.image} alt="medbanner" />
          </div>


          <div className='med_content_sec'>
            <h6 className='med_title'>{blog?.name || " "}</h6>
            <p className='med_desc'>{parse(blog?.description || " ")}</p>

          </div>
          {/* <div className='med_content_sec'>
            <h6 className='med_title'>These practices involve directing and sustaining attention on a single object. When the mind wanders, you
              gently bring it back to the chosen focus.</h6>
            <p className='med_desc'>
              Breath Awareness Meditation: Focusing on the sensations of your breath (inhalation, exhalation, the rise and fall of the abdomen, etc.).
              This is often a foundational practice.

              Mantra Meditation: Repeating a word, phrase, or sound (either aloud or silently) to quiet the mind. "Om" is a well-known example.

              Transcendental Meditation (TM) is a specific, well-known form of mantra meditation.

              Visual Concentration: Focusing on a visual object, such as a candle flame (Trataka), a mandala, or a sacred image.

              Sound Meditation: Concentrating on a specific sound, whether it's external sounds, internal sounds, or the sound of a bell or gong (like in
              sound baths).

              Counting Breaths: A simple technique where you count each exhalation or each full breath cycle to maintain focus.
            </p>

          </div> */}
        </div>
      </section>
    </>
  )
}

export default Meditation_blog_details